import { Box, useMediaQuery } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import AlertCheckBox from "./AlertCheckbox";
import { FileUploader } from "./FileUploader";
import DropdownSelect from "../../../../common/DropdownSelect";
import { bufferOptions } from "./InputOptions";
import { useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../../add/form/types";
import { EditSolutionFormValues } from "../../../edit/form/types";

function RiskMonitoringContainer({ open }: { open: boolean }) {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();
  const hasGeospatialData = Boolean(
    context.values["risk-monitoring"]["geospatial-file"] ||
    context.values["risk-monitoring"]["geospatial-id"],
  );
  const isMobile = useMediaQuery(`(max-width: 1100px)`);
  const existingBuffer =
    context.values["risk-monitoring"]["buffer-value-km"] ?? 10;
  return (
    <>
      <SectionCollapsible open={open} label="Risk Monitoring">
        <Box data-testid="risk-monitoring-details-collapsible">
          <Box
            sx={{
              position: "relative",
              top: "0",
              left: "0",
              float: "left",
              width: "25%",
              aspectRatio: "1/1",
              display: "flex",
              marginTop: "2rem",
            }}
          >
            <FileUploader />
          </Box>
          <Box
            sx={{
              position: "relative",
              top: "0",
              left: "0",
              float: "right",
              width: isMobile ? "50%" : "65%",
              display: "flex",
              flexDirection: "column",
              margin: "1rem",
              marginTop: "5rem",
            }}
          >
            <AlertCheckBox />
            <DropdownSelect
              id={"solution-buffer-selection"}
              name={"risk.monitoring.buffer-value-km"}
              label={"Buffer Value"}
              options={bufferOptions}
              suffix={" km"}
              value={existingBuffer}
              disabled={!hasGeospatialData}
              onChange={(event) =>
                context.setFieldValue(
                  "risk-monitoring.buffer-value-km",
                  event.target.value,
                )
              }
            />
          </Box>
        </Box>
      </SectionCollapsible>
    </>
  );
}

export default RiskMonitoringContainer;
